<template>

    <Skeleton v-if="isLoading" class="h-[40px]"></Skeleton>

    <div v-else class="j-numeric-root">
        <div v-if="quantityButtons" @click="changeQuantity(-1)" class="j-minus">-</div>

        <input
            ref="inputRef"
            class="j-input"
            type="text"
            :readonly="readonly"
            :placeholder="placeholder"
            v-model="valueRef"
            @input="formatNumber"
            @change="changedValue"
        />

        <div v-if="quantityButtons" @click="changeQuantity(1)" class="j-plus">+</div>
    </div>
</template>

<script setup>
import { useNumericInput } from '@jinkosoft/numeric-field'
import {inject, watch} from "vue";

const props = defineProps({
    modelValue      : [ Number, String ],
    readonly        : { type: Boolean, default: false },
    placeholder     : { type: String, default: '' },
    decimalSeparator: { type: String, default: '.' },
    decimals        : { type: Number, default: 0 },
    unsigned        : { type: Boolean, default: true },
    minValue        : { type: Number, default: null },
    quantityButtons : { type: Boolean, default: false },
})

const emit = defineEmits(['updatedValue', 'update:modelValue', 'change'])

const {
    inputRef,
    valueRef,
    formatNumber,
    changedValue,
    changeQuantity,
    setValue
} = useNumericInput(props, emit, {
  enableParseFloat : false,
})

const isLoading     = inject("isLoading", false)

watch(() => props.modelValue, (newVal) => {
    setValue(newVal)
}, { deep: true })
</script>